import { useAllServiceRequestDetails } from '@commenda/api';
import { IndirectTaxClientTaskHelper } from '@commenda/ui/indirect-tax/common/helpers';
import type { IIndirectTaxFilingReviewGroup } from '@commenda/ui/indirect-tax/common/types';
import { useConfig } from 'context/useConfig';
import { useMemo } from 'react';

interface IUseFilingReviewGroupsResult {
  filingReviewGroups: IIndirectTaxFilingReviewGroup[];
  isLoading: boolean;
  error: unknown;
}

export const useFilingReviewGroups = (): IUseFilingReviewGroupsResult => {
  const { companyId } = useConfig();

  // Same SWR key as the sidebar task count, so the request is shared.
  const { data: serviceRequests, error } = useAllServiceRequestDetails(
    companyId ? { companyId } : undefined
  );

  const filingReviewGroups = useMemo(
    () =>
      IndirectTaxClientTaskHelper.getFilingReviewGroups(serviceRequests ?? []),
    [serviceRequests]
  );

  const isLoading = !!companyId && !serviceRequests && !error;

  return { filingReviewGroups, isLoading, error };
};
